import { render, staticRenderFns } from "./JointPunishmentForm.vue?vue&type=template&id=613cf810&scoped=true&"
import script from "./JointPunishmentForm.vue?vue&type=script&lang=js&"
export * from "./JointPunishmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613cf810",
  null
  
)

export default component.exports